import { Pagination } from 'antd';
import { AiOutlineEdit } from 'react-icons/ai';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../Api/apiClient';
import TenderRequestUpdateForm from './TenderRequestUpdateForm';
import { PHOTO_BASE_URL } from './../../Api/config';
import { useMediaQuery } from 'react-responsive';
import { TenderPublishPayment } from '../../Modals/TenderPublishPayment';
const TenderList = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  const [tenderData, setTenderData] = useState([]);
  const [selectedTenderID, setSelectedTenderID] = useState(null); // Track selected tender ID

  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [packagesData, setPackagesData] = useState([]);
  const [selectedTenderData, setSelectedTenderData] = useState(null);

  const userType = localStorage.getItem('user_type');
  const [searchQuery, setSearchQuery] = useState('');

  const updateFormRef = useRef(null);

  const handleModalView = (
    id,
    regular_amount,
    discount_percent,
    discount_amount,
    sub_total,
    ten_req_id
  ) => {
    setSelectedTenderData({
      id,
      discount_percent,
      regular_amount,
      discount_amount,
      sub_total,
      ten_req_id,
    });
    setIsAlertModalOpen(true);

    // console.log(id, subTotal, discountAmount, discountPercent, ten_req_id)
  };

  const handleModalClose = () => {
    setIsAlertModalOpen(false);
    setSelectedTenderData(null);
  };

  // Media query for screen sizes
  const is2xl = useMediaQuery({ query: '(min-width: 1536px)' }); // Matches '2xl' screens and above (min-width: 1536px)

  const [pageSize, setPageSize] = useState(10); // Default page size

  // Update the pageSize dynamically based on screen size
  useEffect(() => {
    if (is2xl) {
      setPageSize(12); // Use 20 for 2xl screens
    } else {
      setPageSize(10); // Use 10 for other screens
    }
  }, [is2xl]);

  // Fetch tender data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiEndpoint =
          userType === 'end_user'
            ? '/user/tender-end-user/publish-tender'
            : userType === 'user'
            ? '/user/tender-user/publish-tender'
            : userType === 'affiliator'
            ? '/affiliator/tender-request/publish-tender'
            : '';
        const response = await apiClient.get(apiEndpoint, {
          params: { key: searchQuery }, // Pass the search query as a query parameter
        });
        // console.log(response.data.data)
        setTenderData(response.data.data);
      } catch (error) {
        console.error('Error fetching tender data:', error);
      }
    };

    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [userType, searchQuery]);

  // const handleSearch = e => setSearchTerm(e.target.value);

  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };

  const filteredAdminList = tenderData.filter(admin =>
    admin.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedAdminList = filteredAdminList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handlePageChange = page => setCurrentPage(page);

  const handleEdit = id => {
    setSelectedTenderID(id); // Update selected tender ID
    if (updateFormRef.current) {
      updateFormRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const getStatusStyle = status => {
    switch (status) {
      case 'published':
        return 'text-green-600';
      case 'verified':
        return 'text-green-500';
      case 'in_review':
        return 'text-yellow-600';
      case 'cancel':
        return 'text-red-600';
      case 'pending':
        return 'text-yellow-500';
      default:
        return 'text-gray-800';
    }
  };
  // Function to format the status text
  const formatStatusText = status => {
    switch (status) {
      case 'published':
        return 'Published';
      case 'in_review':
        return 'In review';
      case 'cancel':
        return 'Canceled';
      case 'pending':
        return 'Pending';
      case 'verified':
        return 'Verified';
      case 'Payment Failed':
        return 'Payment Failed';
      case 'Payment Success':
        return 'Payment Success';
      default:
        return 'Unknown';
    }
  };

  return (
    <div>
      {/* <div className="mt-36 md:px-0 px-2 py-2 container mx-auto flex items-center space-x-4">
        <h1 className="font-bold md:text-sm text-xs">
          View and Update your Tender Publish Request
        </h1>

        <div className="max-w-md flex-grow">
          <input
            value={searchQuery}
            onChange={handleSearchChange}
            type="text"
            className="md:w-[600px] p-2 pl-10 pr-4 border-2 border-gray-300 rounded-xl shadow-lg   transition-all"
            placeholder="Search By Keyword"
          />
        </div>
      </div> */}

      <div className="mt-36 md:px-0 px-2 py-2 container mx-auto flex flex-col md:flex-row items-center space-x-0 md:space-x-4">
        <h1 className="font-bold md:text-sm text-xs text-center md:text-left mb-4 md:mb-0">
          View and Update your Tender Publish Request
        </h1>
        <div className="max-w-md w-full md:w-auto flex-grow ">
          <input
            value={searchQuery}
            onChange={handleSearchChange}
            type="text"
            className="w-full md:w-1/2 p-2  border border-gray-300 rounded-md transition-all text-xs"
            placeholder="Search By Keyword"
          />
        </div>
      </div>

      <div className="flex flex-col md:flex-row w-full container mx-auto gap-4 md:px-0 px-2 py-2">
        {/* Table Section */}
        <div className="overflow-x-auto 2xl:text-xs text-[9px] text-center md:w-4/5 w-full rounded-md md:mb-0 mb-4">
          {/* Table for Larger Devices */}
          <div className="hidden md:block">
            <table className="min-w-full bg-AboutUsBg border border-gray-300">
              <thead>
                <tr className="bg-tenderDetails">
                  <th className="p-2 border-b text-center">S/N</th>
                  <th className="p-2 border-b text-center">Tender Name</th>
                  <th className="p-2 border-b text-center">Request ID</th>
                  <th className="p-3 border-b text-center">Company Name</th>
                  <th className="p-3 border-b text-center">Tender File</th>
                  <th className="p-3 border-b text-center">Company Logo</th>
                  <th className="p-3 border-b text-center">Status</th>
                  <th className="p-3 border-b text-center">Amount</th>
                  <th className="p-3 border-b text-center">Payment Status</th>
                  <th className="p-2 border-b text-center">Update</th>
                </tr>
              </thead>
              <tbody>
                {paginatedAdminList.map((admin, index) => (
                  <tr key={admin.id} className="bg-gray-100">
                    <td className="p-2 border-b">{index + 1}</td>
                    <td className="p-2 border-b">{admin.tender_name}</td>
                    <td className="p-2 border-b">{admin.ten_req_id}</td>
                    <td className="p-2 border-b">{admin.company_name}</td>
                    <td className="p-2 border-b">
                      {admin.tender_file ? (
                        <a
                          href={`${PHOTO_BASE_URL}${admin.tender_file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 hover:underline"
                        >
                          View File
                        </a>
                      ) : (
                        'Empty'
                      )}
                    </td>
                    <td className="p-2 border-b">
                      {admin.company_logo ? (
                        <a
                          href={`${PHOTO_BASE_URL}${admin.company_logo}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 hover:underline"
                        >
                          View Logo
                        </a>
                      ) : (
                        'Empty'
                      )}
                    </td>
                    <td
                      className={`p-2 border-b ${getStatusStyle(admin.status)}`}
                    >
                      {formatStatusText(admin.status)}
                    </td>
                    <td className="p-2 border-b">{admin.regular_amount}</td>
                    <td className="p-2 border-b">
                      {admin.pay_status === 'pay' ? (
                        <button
                          onClick={() =>
                            handleModalView(
                              admin.id,
                              admin.regular_amount,
                              admin.discount_percent,
                              admin.discount_amount,
                              admin.sub_total,
                              admin.ten_req_id
                            )
                          }
                          className="space-x-2 px-2 py-0.5 rounded bg-green-600 hover:bg-green-500 text-white"
                        >
                          Pay now
                        </button>
                      ) : (
                        <span className="text-gray-500">
                          {admin.pay_status}
                        </span>
                      )}
                      <TenderPublishPayment
                        isOpen={isAlertModalOpen}
                        onClose={handleModalClose}
                        tenderData={selectedTenderData || {}}
                      />
                    </td>
                    <td className="p-2 border-b pl-6 2xl:pl-8">
                      <button
                        onClick={() => handleEdit(admin.id)}
                        className="flex items-center justify-center space-x-2 text-gray-600 hover:text-green-600"
                      >
                        <AiOutlineEdit size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Flipped Table Layout for Smaller Devices */}
          <div className="md:hidden">
            <div className="overflow-y-auto max-h-[400px] border border-gray-300 rounded-md">
              <table className="min-w-full bg-AboutUsBg">
                <tbody>
                  {paginatedAdminList.map((admin, index) => (
                    <React.Fragment key={admin.id}>
                      {/* Row for S/N */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          S/N
                        </td>
                        <td className="p-2 border-b text-start">{index + 1}</td>
                      </tr>
                      {/* Row for Tender Name */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Tender Name
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.tender_name}
                        </td>
                      </tr>
                      {/* Row for Request ID */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Request ID
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.ten_req_id}
                        </td>
                      </tr>
                      {/* Row for Company Name */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Company Name
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.company_name}
                        </td>
                      </tr>
                      {/* Row for Tender File */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Tender File
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.tender_file ? (
                            <a
                              href={`${PHOTO_BASE_URL}${admin.tender_file}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View File
                            </a>
                          ) : (
                            'Empty'
                          )}
                        </td>
                      </tr>
                      {/* Row for Company Logo */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Company Logo
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.company_logo ? (
                            <a
                              href={`${PHOTO_BASE_URL}${admin.company_logo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View Logo
                            </a>
                          ) : (
                            'Empty'
                          )}
                        </td>
                      </tr>
                      {/* Row for Status */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Status
                        </td>
                        <td
                          className={`p-2 border-b text-start ${getStatusStyle(
                            admin.status
                          )}`}
                        >
                          {formatStatusText(admin.status)}
                        </td>
                      </tr>
                      {/* Row for Amount */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Amount
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.regular_amount}
                        </td>
                      </tr>
                      {/* Row for Payment Status */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Payment Status
                        </td>
                        <td className="p-2 border-b text-start">
                          {admin.pay_status === 'pay' ? (
                            <button
                              onClick={() =>
                                handleModalView(
                                  admin.id,
                                  admin.regular_amount,
                                  admin.discount_percent,
                                  admin.discount_amount,
                                  admin.sub_total,
                                  admin.ten_req_id
                                )
                              }
                              className="space-x-2 px-2 py-0.5 rounded bg-green-600 hover:bg-green-500 text-white"
                            >
                              Pay now
                            </button>
                          ) : (
                            <span className="text-gray-500">
                              {admin.pay_status}
                            </span>
                          )}
                          <TenderPublishPayment
                            isOpen={isAlertModalOpen}
                            onClose={handleModalClose}
                            tenderData={selectedTenderData || {}}
                          />
                        </td>
                      </tr>
                      {/* Row for Update */}
                      <tr className="bg-gray-100">
                        <td className="p-2 border-b font-bold text-start">
                          Update
                        </td>
                        <td className="p-2 border-b text-start">
                          <button
                            onClick={() => handleEdit(admin.id)}
                            className="flex items-center justify-center space-x-2 text-gray-600 hover:text-green-600"
                          >
                            <AiOutlineEdit size={16} />
                          </button>
                        </td>
                      </tr>
                      {/* Spacer Row */}
                      <tr>
                        <td colSpan={2} className="p-2"></td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-6 flex justify-center">
            <Pagination
              current={currentPage}
              total={filteredAdminList.length}
              pageSize={pageSize}
              onChange={handlePageChange}
            />
          </div>
        </div>

        {/* Update Form Section */}
        <div className="md:w-1/2 w-full">
          <h1 className="md:px-0 px-2 py-2 container mx-auto font-bold md:text-sm text-xs md:hidden block">
            Update your Tender Publish Request
          </h1>
          <div ref={updateFormRef}>
            <TenderRequestUpdateForm tenderID={selectedTenderID} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenderList;

// import { Pagination } from 'antd';
// import { AiOutlineEdit } from 'react-icons/ai';
// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import apiClient from '../../Api/apiClient';
// import TenderRequestUpdateForm from './TenderRequestUpdateForm';
// import { PHOTO_BASE_URL } from './../../Api/config';
// import { useMediaQuery } from 'react-responsive';
// import { TenderPublishPayment } from '../../Modals/TenderPublishPayment';
// const TenderList = () => {
//   const navigate = useNavigate();
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   // const [pageSize, setPageSize] = useState(10);
//   const [tenderData, setTenderData] = useState([]);
//   const [selectedTenderID, setSelectedTenderID] = useState(null); // Track selected tender ID

//   const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
//   const [packagesData, setPackagesData] = useState([]);
//   const [selectedTenderData, setSelectedTenderData] = useState(null);

//   const userType = localStorage.getItem('user_type');
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleModalView = (id, subTotal, discountAmount, discountPercent, ten_req_id) => {
//     setSelectedTenderData({
//       id,
//       subTotal,
//       discountAmount,
//       discountPercent,
//       ten_req_id
//     });
//     setIsAlertModalOpen(true);

//     // console.log(id, subTotal, discountAmount, discountPercent, ten_req_id)
//   };

//   const handleModalClose = () => {
//     setIsAlertModalOpen(false);
//     setSelectedTenderData(null);
//   };

//   // Media query for screen sizes
//   const is2xl = useMediaQuery({ query: '(min-width: 1536px)' }); // Matches '2xl' screens and above (min-width: 1536px)

//   const [pageSize, setPageSize] = useState(10); // Default page size

//   // Update the pageSize dynamically based on screen size
//   useEffect(() => {
//     if (is2xl) {
//       setPageSize(12); // Use 20 for 2xl screens
//     } else {
//       setPageSize(10); // Use 10 for other screens
//     }
//   }, [is2xl]);

//   // Fetch tender data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const apiEndpoint =
//           userType === 'end_user'
//             ? '/user/tender-end-user/publish-tender'
//             : userType === 'user'
//             ? '/user/tender-user/publish-tender'
//             : userType === 'affiliator'
//             ? '/affiliator/tender-request/publish-tender'
//             : '';
//         const response = await apiClient.get(apiEndpoint, {
//           params: { key: searchQuery }, // Pass the search query as a query parameter
//         });
//         // console.log(response.data.data)
//         setTenderData(response.data.data);
//       } catch (error) {
//         console.error('Error fetching tender data:', error);
//       }
//     };

//     fetchData();
//     const interval = setInterval(() => {
//       fetchData();
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [userType, searchQuery]);

//   // const handleSearch = e => setSearchTerm(e.target.value);

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   }

//   const filteredAdminList = tenderData.filter(admin =>
//     admin.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const paginatedAdminList = filteredAdminList.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );

//   const handlePageChange = page => setCurrentPage(page);

//   const handleEdit = id => {
//     setSelectedTenderID(id); // Update selected tender ID
//   };

//   const getStatusStyle = status => {
//     switch (status) {
//       case 'published':
//         return 'text-green-600';
//       case 'verified':
//         return 'text-green-500';
//       case 'in_review':
//         return 'text-yellow-600';
//       case 'cancel':
//         return 'text-red-600';
//       case 'pending':
//         return 'text-yellow-500';
//       default:
//         return 'text-gray-800';
//     }
//   };
//   // Function to format the status text
//   const formatStatusText = status => {
//     switch (status) {
//       case 'published':
//         return 'Published';
//       case 'in_review':
//         return 'In review';
//       case 'cancel':
//         return 'Canceled';
//       case 'pending':
//         return 'Pending';
//       case 'verified':
//         return 'Verified';
//       case 'Payment Failed':
//         return 'Payment Failed';
//       case 'Payment Success':
//         return 'Payment Success';
//       default:
//         return 'Unknown';
//     }
//   };

//   return (
//     <div>
//       {/* <div className="mt-36 md:px-0 px-2 py-2 container mx-auto flex items-center space-x-4">
//         <h1 className="font-bold md:text-sm text-xs">
//           View and Update your Tender Publish Request
//         </h1>

//         <div className="max-w-md flex-grow">
//           <input
//             value={searchQuery}
//             onChange={handleSearchChange}
//             type="text"
//             className="md:w-[600px] p-2 pl-10 pr-4 border-2 border-gray-300 rounded-xl shadow-lg   transition-all"
//             placeholder="Search By Keyword"
//           />
//         </div>
//       </div> */}

//       <div className="mt-36 md:px-0 px-2 py-2 container mx-auto flex flex-col md:flex-row items-center space-x-0 md:space-x-4">
//         <h1 className="font-bold md:text-sm text-xs text-center md:text-left mb-4 md:mb-0">
//           View and Update your Tender Publish Request
//         </h1>
//         <div className="max-w-md w-full md:w-auto flex-grow ">
//           <input
//             value={searchQuery}
//             onChange={handleSearchChange}
//             type="text"
//             className="w-full md:w-1/2 p-2  border border-gray-300 rounded-md transition-all text-xs"
//             placeholder="Search By Keyword"
//           />
//         </div>
//       </div>

//       <div className="flex flex-col md:flex-row w-full container mx-auto gap-4 md:px-0 px-2 py-2">
//         <div className="overflow-x-auto 2xl:text-xs text-[9px] text-center md:w-4/5 w-full rounded-md md:mb-0 mb-4">
//           <table className="min-w-full bg-AboutUsBg border border-gray-300">
//             <thead>
//               <tr className="bg-tenderDetails">
//                 <th className="p-2 border-b text-center">S/N</th>
//                 <th className="p-2 border-b text-center">Tender Name</th>
//                 <th className="p-2 border-b text-center">Request ID</th>
//                 <th className="p-3 border-b text-center">Company Name </th>
//                 <th className="p-3 border-b text-center">Tender File</th>
//                 <th className="p-3 border-b text-center">Company Logo</th>
//                 <th className="p-3 border-b text-center">Status</th>
//                 <th className="p-3 border-b text-center">Amount</th>
//                 <th className="p-3 border-b text-center">Payment Status</th>
//                 <th className="p-2 border-b text-center">Update</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedAdminList.map((admin, index) => (
//                 <tr key={admin.id} className="bg-gray-100 ">
//                   <td className="p-2 border-b"> {index + 1}</td>
//                   <td className="p-2 border-b">{admin.tender_name}</td>
//                   <td className="p-2 border-b">{admin.ten_req_id}</td>
//                   <td className="p-2 border-b">{admin.company_name}</td>
//                   {/* <td className="p-2 border-b">{admin.tender_file}</td> */}
//                   <td className="p-2 border-b">
//                     {admin.tender_file ? (
//                       <a
//                         href={`${PHOTO_BASE_URL}${admin.tender_file}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="text-blue-500 hover:underline "
//                       >
//                         View File
//                       </a>
//                     ) : (
//                       'Empty'
//                     )}
//                   </td>
//                   <td className="p-2 border-b">
//                     {admin.company_logo ? (
//                       <a
//                         href={`${PHOTO_BASE_URL}${admin.company_logo}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="text-blue-500 hover:underline "
//                       >
//                         View Logo
//                       </a>
//                     ) : (
//                       'Empty'
//                     )}
//                   </td>

//                   {/* <td className="p-2 border-b">{admin.status}</td> */}
//                   <td
//                     className={`p-2 border-b ${getStatusStyle(admin.status)}`}
//                   >
//                     {formatStatusText(admin.status)}
//                   </td>
//                   <td className="p-2 border-b">{admin.sub_total}</td>
//                   <td className="p-2 border-b">
//                     {admin.pay_status === 'pay' ? (
//                       <button
//                         onClick={() =>
//                           handleModalView(
//                             admin.id,
//                             admin.sub_total,
//                             admin.discount_amount,
//                             admin.discount_percent,
//                             admin.ten_req_id
//                           )
//                         }
//                         className="space-x-2 px-2 py-0.5 rounded bg-green-600 hover:bg-green-500 text-white"
//                       >
//                         Pay now
//                       </button>
//                     ) : (
//                       <span className="text-gray-500">{admin.pay_status}</span>
//                     )}
//                     <TenderPublishPayment
//                       isOpen={isAlertModalOpen}
//                       onClose={handleModalClose}
//                       tenderData={selectedTenderData || {}}
//                     />
//                   </td>

//                   <td className="p-2 border-b pl-6 2xl:pl-8">
//                     <button
//                       onClick={() => handleEdit(admin.id)}
//                       className="flex items-center justify-center space-x-2 text-gray-600 hover:text-green-600"
//                     >
//                       <AiOutlineEdit size={16} />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <div className="mt-6 flex justify-center">
//             <Pagination
//               current={currentPage}
//               total={filteredAdminList.length}
//               pageSize={pageSize}
//               onChange={handlePageChange}
//             />
//           </div>
//         </div>
//         <div className="md:w-1/2 w-full">
//           <h1 className="md:px-0 px-2 py-2 container mx-auto font-bold md:text-sm text-xs md:hidden block">
//             Update your Tender Publish Request
//           </h1>
//           <TenderRequestUpdateForm tenderID={selectedTenderID} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TenderList;
